import { CdkTableModule } from "@angular/cdk/table";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { RouterLink } from "@angular/router";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { NgxEchartsModule } from "ngx-echarts";

import { BaseComponentsModule } from "../../base/components/base-components.module";
import { BleStatusComponent } from "./ble-status/ble-status.component";
import { CommentsComponent } from "./comments/comments.component";
import { CsvExportSettingsComponent } from "./csv-export-settings/csv-export-settings.component";
import { DemoTemplateInstallerComponent } from "./demo-template-installer/demo-template-installer.component";
import { DeviceConnectorComponent } from "./device-connector/device-connector.component";
import { ErrorDialogComponent } from "./error-dialog/error-dialog.component";
import { GraphComponent } from "./graph/graph.component";
import { MeasurementTableComponent } from "./measurement-table/measurement-table.component";
import { MenubarComponent } from "./menubar/menubar.component";
import { OnboardingInfoComponent } from "./onboarding/onboarding-info.component";
import { PartEditorComponent } from "./part-editor/part-editor.component";
import { PartSelectorComponent } from "./part-selector/part-selector.component";
import { PartSelectorDialogComponent } from "./part-selector-dialog/part-selector-dialog.component";
import { PartViewComponent } from "./part-view/part-view.component";
import { PhotoListComponent } from "./photo-list/photo-list.component";
import { RegisterFormComponent } from "./register-form/register-form.component";
import { ScanDevicesComponent } from "./scan-devices/scan-devices.component";
import { SelectJobTemplateComponent } from "./select-job-template/select-job-template.component";
import { TemplateBrowserComponent } from "./template-browser/template-browser.component";

/**
 * The module for the business components.
 */
@NgModule({
    declarations: [
        PartSelectorDialogComponent,
        PartSelectorComponent,
        PartEditorComponent,
        DeviceConnectorComponent,
        MeasurementTableComponent,
        MenubarComponent,
        PartViewComponent,
        CommentsComponent,
        SelectJobTemplateComponent,
        PhotoListComponent,
        DemoTemplateInstallerComponent,
        OnboardingInfoComponent,
        ErrorDialogComponent,
        RegisterFormComponent,
        BleStatusComponent,
        GraphComponent,
        ScanDevicesComponent,
        TemplateBrowserComponent,
        CsvExportSettingsComponent
    ],
    exports: [
        PartSelectorDialogComponent,
        PartSelectorComponent,
        PartEditorComponent,
        DeviceConnectorComponent,
        MeasurementTableComponent,
        MenubarComponent,
        PartViewComponent,
        PhotoListComponent,
        BleStatusComponent,
        GraphComponent,
        ScanDevicesComponent,
        TemplateBrowserComponent,
        CsvExportSettingsComponent
    ],
    imports: [
        CommonModule,
        FontAwesomeModule,
        MatButtonModule,
        MatTableModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        FormsModule,
        TranslateModule,
        BaseComponentsModule,
        MatListModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatMenuModule,
        NgOptimizedImage,
        MatProgressSpinnerModule,
        RouterLink,
        CdkTableModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        IonicModule,
        NgxEchartsModule.forRoot({
            echarts: () => import("echarts")
        }),
        MatChipsModule
    ]
})
export class BusinessComponentsModule {
}
